import { render, staticRenderFns } from "./filters.pug?vue&type=template&id=31fb1dc2&lang=pug&external"
import script from "./filters.js?vue&type=script&lang=js&external"
export * from "./filters.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fb1dc2')) {
      api.createRecord('31fb1dc2', component.options)
    } else {
      api.reload('31fb1dc2', component.options)
    }
    module.hot.accept("./filters.pug?vue&type=template&id=31fb1dc2&lang=pug&external", function () {
      api.rerender('31fb1dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/components/filters/index.vue"
export default component.exports